module.exports = __webpack_public_path__ + "img/Lecturer-2-800-COMPRESSED.56eb9134.gif";